import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/generate-expense", "documento": "invoices", "acceso": "sesion", "filas": ["024"], "cita": "prod:Areas/Invoices/Controllers/GenerateController.cs:82"} satisfies RutaProd;
